export class Element {
  el;

  constructor(sel?, par?) {
    this.el = par ? par.querySelector(sel) : document.querySelector(sel);
  }

  div() {
    this.el = document.createElement('div');
    return this;
  }

  tgs() {
    this.el = document.createElement('tgs-player');
    return this;
  }

  ch(ch) {
    this.el.appendChild(ch);
  }

  ac(cl) {
    this.el.classList.add(cl);
  }

  rc(cl) {
    this.el.classList.remove(cl);
  }

  ga(at) {
    this.el.getAttribute(at);
  }

  sa(at, vl) {
    this.el.setAttribute(at, vl);
  }

  set html(html) {
    this.el.innerHTML = html;
  }

  set src(src) {
    this.el.src = src;
  }

  set click(cb) {
    this.el.addEventListener('click', cb);
  }
}
